import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer
      style={{
        background: '#14532D',
        padding: '46px 24px',
        textAlign: 'center',
        borderRadius: '40px 40px 0 0',
        color: '#fff'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 11 }}>
        <img src="/uploads/jashyl-logo-white.svg" alt="Жашыл дем" style={{ height: 32 }} />
        <span style={{ font: "700 19px 'Montserrat Alternates', sans-serif", color: '#fff' }}>
          Жашыл дем
        </span>
      </div>
      <div
        style={{
          font: "400 13.5px 'Golos Text', sans-serif",
          color: 'rgba(255,255,255,.85)',
          marginTop: 14
        }}
      >
        {t('footer.copyright')}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 20, marginTop: 10, flexWrap: 'wrap' }}>
        <a
          href="/docs/personal-data.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#fff', font: "400 13.5px 'Golos Text', sans-serif" }}
        >
          {t('footer.personal')}
        </a>
        <a
          href="/docs/terms.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#fff', font: "400 13.5px 'Golos Text', sans-serif" }}
        >
          {t('footer.terms')}
        </a>
        <a
          href="/docs/payments.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#fff', font: "400 13.5px 'Golos Text', sans-serif" }}
        >
          {t('footer.payments')}
        </a>
      </div>
      <img
        src="/uploads/fig/visa-mc.png"
        alt="Visa / Mastercard"
        style={{ height: 28, marginTop: 20, background: '#fff', borderRadius: 8, padding: '5px 12px', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
      />
    </footer>
  );
};

export default Footer;
